import React, { Component } from "react";
import data from "./ProjectData";
export default class index extends Component {
  constructor(props) {
    super(props);
    const { id } = this.props.match.params;
    this.state = {
      key: id,
      path: "",
    };
  }
  componentDidMount() {
    data[this.state.key].img.then((res) =>
      this.setState({ path: res.default })
    );
  }
  render() {
    const { key } = this.state;
    return (
      <div
        id="projectDetails"
        className="more--info__container"
        style={{ marginTop: "7rem" }}
      >
        <div className="more--info__wrapper">
          <img className="more--info__image" src={this.state.path} alt="" />
          <div className="row">
            <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
              <div className="info--data">
                <h4>{data[key].title}</h4>
                <p>{data[key].Description}</p>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
              <div className="tech--stack__data">
                <h4>Technologies Used:</h4>
                <p>{data[key].techUsed}</p>
                {data[key].siteLink.length !== 0 && (
                  <a href={data[key].siteLink} className="mr-4">
                    {data[key].siteLink.match(/(https:)?\/\/(github.com)/)
                      ? "Download Apk"
                      : "Visit Site"}
                    &rarr;
                  </a>
                )}
                {data[key].githubLink.length !== 0 && (
                  <a href={data[key].githubLink}>Code &rarr;</a>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
